import i18n from 'i18next';
import authService from 'lib/api-authorization/AuthorizeService';
import { rootStore } from 'models/rootModel';
import { endpoints } from '../endpoints';
import { parseResponse } from '../parseResponse';

export async function getHeader(method, tenantId) {
  const header = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': getLanguageString(i18n.languages[0])
    }
  };

  if (tenantId || rootStore.municipality.tenantId) {
    header.headers.tenantId = tenantId ? tenantId : rootStore.municipality.tenantId;
  }

  const token = await authService.getAccessToken();
  if (token) {
    header.headers['Authorization'] = `Bearer ${token}`;
  }

  return header;
}

export async function getLicense() {
  return fetch(`${endpoints.license}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function getUser() {
  return fetch(`${endpoints.user}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function getExternalUsers() {
  return fetch(`${endpoints.user}/ExternalUsers`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function updateUser(user) {
  return fetch(`${endpoints.user}`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify(user)
  }).then(parseResponse);
}

export async function getLocatorSuggestions(url) {
  return fetch(url, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export function getVersionNumber() {
  return fetch(`${endpoints.DPVersionNumber}`, {
    ...getHeader('GET')
  }).then(parseResponse);
}

function getLanguageString(shortLanguageString) {
  if (shortLanguageString.startsWith('sv')) {
    return 'sv-SE';
  } else if (shortLanguageString.startsWith('pl')) {
    return 'pl-PL';
  } else {
    return 'en-US';
  }
}
